import React, {useCallback, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import {file, global, input, weekDays} from "../translate";
import {useDispatch} from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {REACT_APP_API_URL} from '../config';
import Api from "../Api";
import {fileOpenCreateRequest, fileRequest} from "../store/actions/file";
import {toast} from "react-toastify";
const {REACT_APP_SERVER} = process.env;

import {style,} from "../helpers/style";


function OpenAi({open, setOpen}) {
    const [form, setForm] = useState({
        voiceName:'',
        name:'',
        text:'',
    })

    const [voices] = useState(['alloy', 'nova', 'fable', 'shimmer'])


    const dispatch = useDispatch()

    const handleChange = useCallback((name,ev) => {
        setForm((prevState) => ({
            ...prevState,
            [name]:ev
        }))
        if(name==="voiceName"){
            const audio = new Audio(`${REACT_APP_API_URL}${((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') ? '/rest':'')}/file_voice/openai/${ev}_sample.mp3`);
            audio.play().then(r => console.log('Audio playing'));
        }

    }, [])
    const handleAdd = useCallback(async () => {
        const {data} = await Api.fileOpenAi(form)
        if (data.status === 'processing') {
            toast.info("Processing file, please wait...")
            const checkStatus = async (interval = 5000) => {
                const res = await Api.fetchOpenAi(`${data.fileId}`);
                if (res.data.status === 'ready') {
                    toast.success("File is ready");
                    // Update UI, stop polling
                    await dispatch(fileRequest())
                } else if (res.data.status === 'failed') {
                    console.error("Failed to process the file.");

                } else {
                    setTimeout(checkStatus, interval);
                }
            };

            checkStatus();

        }else{
            toast.error("Failed to process the file");
        }

        // await dispatch(fileOpenCreateRequest(form))
        setOpen(false)
    }, [form])
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            Open AI
                        </Typography>
                        <span style={{cursor: 'pointer'}} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </span>
                    </div>
                    <div id="transition-modal-description sip_content" style={{marginTop: 10}}>
                        <div className="row">
                            <div className="col-md-12" style={{marginTop:10}}>
                                <span>{file.myYandex[+localStorage.getItem('atsLang')  || 1]}</span>
                                <input value={form.name} onChange={ev => handleChange('name',ev.target.value)} style={{width:'100%',height:40 , padding:10,  outline: 'none',
                                    border: '1px solid'}} />
                            </div>
                            <label className="col-md-6" style={{marginTop:20}}>
                                <span>{file.myVT[+localStorage.getItem('atsLang')  || 1]}</span>
                                <textarea value={form.text} onChange={ev => handleChange('text',ev.target.value)} style={{width:'100%',height:130 ,outline: 'none',
                                    border: '1px solid'}} />
                            </label>


                            <label className="col-md-6"  style={{marginTop:30}} >
                                {voices.map(s => (
                                    <div>
                                        <div className="radio-item"><input name="radio" onClick={() => handleChange('voiceName',s)} checked={form.voiceName === s} id={s} type="radio"/><label
                                            htmlFor={s}>{s}</label></div>
                                    </div>
                                ))}
                            </label>
                        </div>
                        <div className="d-flex justify-content-center" style={{marginTop: '40px'}}>
                            <button className="addBtn"
                                    onClick={handleAdd}
                                    style={{margin: '10px 0'}}>{global.add[+localStorage.getItem('atsLang')  || 1]}</button>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default OpenAi;
